import React, { FC } from 'react';

type Props = {
  children: JSX.Element;
  className?: string;
  preventContextMenu?: boolean;
  onClick?: () => void;
};

const PreventDownloadContainer: FC<Props> = ({ children, className, preventContextMenu, onClick }) => {
  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
      <div
        className={className}
        onContextMenu={(e) => {
          if (preventContextMenu) {
            e.stopPropagation();
            e.preventDefault();
          }
        }}
        onClick={onClick}
      >
        {children}
      </div>
    </>
  );
};

export default PreventDownloadContainer;
